/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ListResponseSchemaResource } from '../models/list-response-schema-resource';


/**
 * Scim schemas controller
 */
@Injectable({
  providedIn: 'root',
})
export class ScimSchemasV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation scimSchemasV1
   */
  static readonly ScimSchemasV1Path = '/v1/integration/scim/v2/Schemas';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scimSchemasV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  scimSchemasV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListResponseSchemaResource>> {

    const rb = new RequestBuilder(this.rootUrl, ScimSchemasV1Service.ScimSchemasV1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/scim+json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListResponseSchemaResource>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scimSchemasV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scimSchemasV1(params?: {
  },
  context?: HttpContext

): Observable<ListResponseSchemaResource> {

    return this.scimSchemasV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListResponseSchemaResource>) => r.body as ListResponseSchemaResource)
    );
  }

}
